import React, { useCallback } from 'react';
import Layout from 'antd/lib/layout/layout';
import { FormikProvider, useFormik, Form } from 'formik';
import isEqual from 'lodash.isequal';
import Breadcrumb from 'antd/lib/breadcrumb';
import PageTitle from '../../lib/page-title';
import FormControl from '../../lib/form-control';
import LeavePageModal from '../../lib/leave-page-modal';
import PrimaryButton from '../../lib/primary-button';
import useCreateReportGroup from './use-createReportGroup';
import { useActions } from '../../providers/actions-provider/actions.context';
import breadcrumbSeparator from '../../../assets/icons/breadcrumbSeparator.svg';
import BreadcrumbItem from '../../lib/breadcrumbItem';
import SecondaryButton from '../../lib/secondary-button';

const CreateReportGroup = () : JSX.Element => {
  const {
    initialValues, isEdit, dataForCrumbs, id, reportGroup,
  } = useCreateReportGroup();
  const { reportActions } = useActions();
  const formik = useFormik({
    initialValues,
    onSubmit: (values) => {
      if (isEdit) {
        reportActions.editReportGroup(id, values);
      } else {
        reportActions.createReportGroup(values);
      }
    },
    enableReinitialize: true,
  });

  const { isSubmitting, values } = formik;
  const formHasChanged = !isEqual(initialValues, values);

  const deleteGroup = useCallback(() => {
    if (id) {
      reportActions.deleteReportGroup(id);
    }
  }, [id]);

  return (
    <Layout className="main-container">
      <Breadcrumb
        itemRender={BreadcrumbItem}
        routes={dataForCrumbs}
        separator={<img src={breadcrumbSeparator} alt="breadcrumb separator" />}
        params={{ dataForCrumbs }}
      />
      <PageTitle back title={isEdit ? 'Edit Folder' : 'New Folder'}>
        {isEdit && reportGroup && <SecondaryButton title="Delete Folder" onClick={deleteGroup} />}
      </PageTitle>
      <FormikProvider value={formik}>
        <Form className="formik-form">
          <FormControl inputClassName="formik-form__input" name="name" label="Name" type="text" />
          <PrimaryButton disabled={!formHasChanged} type="submit" className="formik-form__submit">
            Save
          </PrimaryButton>
        </Form>
      </FormikProvider>
      {formHasChanged && !isSubmitting && <LeavePageModal /> }

    </Layout>
  );
};

export default CreateReportGroup;
